import { EventTypes, PinchState } from '@use-gesture/react';
import { ScaleTime } from 'd3-scale';

const pinchGestureMultiplier = 100;

export const getNextZoomLevel = (
  xScale: ScaleTime<number, number>,
  event: PinchState & { event: EventTypes['pinch'] },
) => {
  const [rangeMin, rangeMax] = xScale.range() as [number, number];
  const delta = event.delta[0] * pinchGestureMultiplier;
  const newMin = xScale.invert(rangeMin + delta);
  const newMax = xScale.invert(rangeMax - delta);
  return { newMin, newMax };
};
